import React from "react";

function RIGHT_ANGLED_HELI_WORM_GEARED_MOTOR() {
  return (
    <>
      <div className="container p-5">
        <h1>SERIES C - RIGHT ANGLED HELI-WORM GEARED MOTOR</h1>
        <hr></hr>
        <div className="row">
          <div className="col-md-5">
            <img src="./images/ProImages/RIGHT-ANGLED-HELI-WORM-GEARED-MOTOR.png"></img>
          </div>

          <div className="col-md-7 mt-5">
            <p className="fs-1">
              <b> Unit Sizes</b> :03, 04, 05, 06, 07, 08, 09, and 10
            </p>
            <p className="fs-1">
              {" "}
              <b>Input Power</b> : Up to 45kW
            </p>
            <p className="fs-1">
              {" "}
              <b>Output Torque</b> : Upto 10,000 N-m{" "}
            </p>
            <p className="fs-1">
              {" "}
              <b>Gear Ratios</b> :Upto 16,000:1
            </p>
            <p className="fs-1">
              {" "}
              <b>Motor Sizes IIEC Frames from</b> :  63 to 225
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default RIGHT_ANGLED_HELI_WORM_GEARED_MOTOR;
